import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/newsletter/$newsletterId/overview/',
)({
  beforeLoad: ({ params, location }) => {
    throw redirect({
      to: '/workspaces/$workspaceId/broadcasts/newsletter/$newsletterId/overview/reports',
      params,
      search: location.search,
      hash: location.hash,
      replace: true,
    });
  },
});
